import { InjectionToken } from '@angular/core';

export interface TealeafCaptureLibrary {
  logCustomEvent(description: string, data: object): void;
}

export const TEALEAF = new InjectionToken<TealeafCaptureLibrary | undefined>(
  'TealeafCaptureLibrary',
  {
    providedIn: 'root',
    factory: tealeafFactory,
  },
);

declare const TLT: TealeafCaptureLibrary;

export function tealeafFactory(): TealeafCaptureLibrary {
  if (typeof TLT !== 'undefined') {
    return TLT;
  }

  // eslint-disable-next-line no-console
  console.warn('Tealeaf capture library (TLT) not found');

  return {
    logCustomEvent: () => {},
  };
}
